import { getApps, initializeApp } from "firebase/app";
import {
  inMemoryPersistence,
  initializeAuth,
  type Auth,
} from "firebase/auth";
import { useEffect, useState } from "react";
import { useEnv } from "~/hooks/use-env";
import { WEB_FIREBASE_APP_NAME } from "~/utils/auth-rollout";

let clientAuth: Auth | undefined;

export const useClientAuth = () => {
  const env = useEnv();
  const [auth, setAuth] = useState<Auth>();

  useEffect(() => {
    const app =
      getApps().find(({ name }) => name === WEB_FIREBASE_APP_NAME) ??
      initializeApp(
        {
          apiKey: env.FIREBASE_API_KEY,
          authDomain: env.FIREBASE_AUTH_DOMAIN,
          projectId: env.FIREBASE_PROJECT_ID,
          appId: env.FIREBASE_APP_ID,
        },
        WEB_FIREBASE_APP_NAME,
      );
    const initializedAuth =
      clientAuth ??
      (clientAuth = initializeAuth(app, {
        persistence: inMemoryPersistence,
      }));

    setAuth(initializedAuth);
  }, [env]);

  return auth;
};
